module.exports = __webpack_public_path__ + "static/img/dorm-warn.4232491.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/dorm-warn.png
// module id = 50O7
// module chunks = 58